import { pathBuilder } from 'config/paths/index';

export const root = '/admin/badges';
export default pathBuilder(root);
